var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 245,
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-325 -245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.25 280.833 346.25 275.75C350.958 275.125 354.583 271.125 354.583 266.25L354.583 262.083 352.083 262.083 352.083 266.25C352.083 270.167 348.917 273.333 345 273.333 341.083 273.333 337.917 270.167 337.917 266.25L337.917 262.083 335.417 262.083 335.417 266.25C335.417 271.125 339.042 275.125 343.75 275.75L343.75 280.833 335 280.833 335 283.333 355 283.333 355 280.833 346.25 280.833Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 271.667C348 271.667 350.417 269.25 350.417 266.25L346.25 266.25 346.25 264.583 350.417 264.583 350.417 262.083 346.25 262.083 346.25 260.417 350.417 260.417 350.417 257.917 346.25 257.917 346.25 256.25 350.417 256.25 350.417 253.75 346.25 253.75 346.25 252.083 350.417 252.083C350.417 249.083 348 246.667 345 246.667 342 246.667 339.583 249.083 339.583 252.083L339.583 266.25C339.583 269.25 342 271.667 345 271.667Z",
    fill: "#D9D9D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioLogo);
export default __webpack_public_path__ + "static/media/audio-logo.93cce1508de1d1b88539910addbbc4c2.svg";
export { ForwardRef as ReactComponent };